<template>
    <header class="header" :class="{ 'with-sidebar': user }">
        <div class="logo main-logo flex-1 flex justify-start" v-if="!user">
            <router-link class='no-underline' to="/">
                <div class="logo-img ml-30"><span>KYCWISE</span></div>
            </router-link>
        </div>
        <div v-if="!user && route.path && !isMobile" class="middle-nav flex gap-25 justify-center" style="flex: 1" :class="{'user': user}">
                <div id='navigator-home_section' class="header-item navigator" @click="goToSection('home_section')">Home</div>
                <div id='navigator-about' class="header-item navigator" @click="goToSection('about')">About</div>
                <div id='navigator-compliance' class="header-item navigator" @click="goToSection('compliance')">Compliance</div>
                <div id='navigator-features' class="header-item navigator" @click="goToSection('features')">Features</div>
                <div id='navigator-pricing' class="header-item navigator" @click="goToSection('pricing')">Pricing</div>
                <div id='navigator-contact' class="header-item navigator" @click="goToSection('contact')">Contact</div>
                <div id='navigator-demo' class="header-item navigator" @click="goToSection('demo')">
                    Demo
                </div> 
        </div>
        <div class="header-nav flex-1 flex justify-end gap-20"> 
            
            <div class='header-item flex gap-20' style='margin-right: 30px;' v-if="!user && !limitedUser">
                <router-link class="link-item" to="/login">
                     <button class="button transparent" >Log in</button>
                </router-link> 
                <router-link class="link-item" to="/register">
                    <button class="button">Sign Up for Free</button>
                </router-link> 
            </div>
            <Dropdown v-if="user" class="drop-down"/>
        </div>
        <div class="sidebaropener" v-if="isMobile && !user" @click="() => sidebarOpen = true">
            <img src="@/assets/menu-burger.svg" class="burger"/>
        </div>
        <div v-if="!user" class="sidebar flex column border-box" :class="`${sidebarOpen ? 'open': ''}`">
            <div class="logo flex justify-between side-header">
                <router-link class='no-underline' to="/">
                    <div class="logo-img ml-30"><span>KYCWISE</span></div>
                </router-link>
                <div class="cross" @click="sidebarOpen = false">
                    <img src="@/assets/cross.svg" alt="cross"/>
                </div>
            </div>
            <div class="body-sidemenu">
                <div>
                    <div class='header-item flex gap-20' v-if="!user && !limitedUser">
                        <router-link class="link-item flex-1" @click="() => sidebarOpen = false" to="/login">
                            <button class="button transparent" >Log in</button>
                        </router-link> 
                        <router-link class="link-item flex-1" @click="() => sidebarOpen = false" to="/register">
                            <button class="button">Sign Up for Free</button>
                        </router-link> 
                    </div>
                </div>
                <div id='navigator-home_section' class="header-item navigator" @click="goToSection('home_section')">Home</div>
                <div id='navigator-about' class="header-item navigator" @click="goToSection('about')">About</div>
                <div id='navigator-compliance' class="header-item navigator" @click="goToSection('compliance')">Compliance</div>
                <div id='navigator-features' class="header-item navigator" @click="goToSection('features')">Features</div>
                <div id='navigator-pricing' class="header-item navigator" @click="goToSection('pricing')">Pricing</div>
                <div id='navigator-contact' class="header-item navigator" @click="goToSection('contact')">Contact</div>
                <div id='navigator-demo' class="header-item navigator" @click="goToSection('demo')">
                    Demo
                </div> 

            </div>
        </div>
    </header>
</template>

<script setup >

    import { mapState } from 'vuex';
    import API from '../api/index.js'
    import Dropdown from './userDropDown.vue'
    import store from '../store/index.js'
    import { useRoute, useRouter } from 'vue-router'
    import { computed, onMounted, ref } from 'vue'
    
    const route = useRoute();
    const router = useRouter();
    const sidebarOpen = ref(false);

    const isMobile = computed(() => store.state.isMobile);
    const user = computed(() => store.state.user)
    const limitedUser = computed(() => store.state.limitedUser)
    function goToSection(sectionId) {
        sidebarOpen.value = false;
        if (route.path !== '/') {
            router.push('/').then(() => {
                store.dispatch('goToSection', { sectionId: sectionId })
            });
        } else {
            store.dispatch('goToSection', { sectionId: sectionId })
            if (sectionId == 'demo') {
                router.push('/demo')
            }
        }
    }
</script>

<style lang="scss" scoped>
.header-nav {
    padding: 0;
    height: 100%;
    display: flex;
    position: relative;
}
.navigator.active {
    color: rgb(37 99 235);
}
.drop-down {
    margin-right: 20px;
}
.burger {
    margin-right: 20px;
    width: 25px;
}
.body-sidemenu {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 25px;

    .navigator {
        display: flex;
        justify-content: flex-start;
        font-size: 18px;
    }
    .header-item {
        display: flex;

    }
}
.header-item a{
    text-decoration: none;

}
.navigator {
    font-size: 14px;
    font-weight: 500;
    color: #091440;
    cursor: pointer;
    min-width: 100px;
    font-weight: bolder;
}
.navigator:hover {
    color: rgb(37 99 235);
}

.middle-nav.user {
    padding-left: calc(var(--sidebar-width) / 3 * 2);
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: white;
    border-bottom: 1px solid var(--border-color);
    box-sizing: border-box;
    &.with-sidebar {
        left: var(--sidebar-width);
        width: auto;
        transition: left 0.2s ease;
    }
}
.header-nav ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    &.special {
        display: flex;
        align-items: center;
        width: fit-content;
    }
}
.header-item {
    display: flex;
    align-items: center;
    justify-content: center;
}
.header-nav li {
    display: inline-block;
    margin: 0 15px;
    font-size: 12px;
    a {
        padding: 15px 0;
    }
}

.header-nav a, .header-nav span{
    text-decoration: none;
    color: #091440;
    cursor: pointer;
    font-weight: bolder;
}

.header-nav a:hover, .header-nav span:hover{
    color: #10193e;
}

.section-white {
    text-decoration: none;
    color: #091440; 
    display: inline-block;
    margin: 0 15px;

}
.list-of-links {
    display: flex;
    align-items: center;
}
.greeting {
    margin-left: auto;
    white-space: nowrap;
    font-size: 12px;
}
.logout {
    font-size: 12px;
    font-weight: bolder;
    cursor: pointer;
    &:hover {
        color: #10193e;
    }
}
.register {
    margin-left: auto;
}
.notification-parent[class] {
    position: relative;
    margin-right: 30px;
}
.notification-counter {
    background: #f59f9f;
    border-radius: 50%;
    padding: 5px;
    top: -2px;
    right: -20px;
    position: absolute;
}
#navigator-demo {
    
}
.navigator {
  transform: scale(1);
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  perspective: 1000px;
}
.navigator:hover {
  transform: scale(1.1);
}
.side-header {
    padding: 8px 10px 10px 0px;
    border-bottom: 1px solid var(--border-color);
}
.sidebar {
    position: absolute;
    display: flex;
    right: -100%;
    width: 100%;
    height: calc(100vh);
    top: 0px;
    background: white;
    transition: right 0.15s ease-in-out;
    &.open {
        right: 0%;
    }
}
@media screen and (max-width: 1300px) {
  .middle-nav {
    gap: 0px;
    flex: 3;

  }
  .header-nav {
    flex: 2;
  }
  
}
@media screen and (max-width: 1000px) {
    .navigator {
        min-width: unset;
    } 
    .middle-nav {
        gap: 20px
    }
    .main-logo {
        margin-right: 30px;
    }
}
@media screen and (max-width: 780px) {
    .navigator {
        min-width: unset;
        font-size: 12px;
    } 
    .middle-nav {
        gap: 20px
    }
     .main-logo {
        flex: unset
    }
}
@media screen and (max-width: 820px) {
    .navigator:hover {
        transform: none;
    }
   
}


</style>
